import "../../../Styles/tab.component.css";

import { Paper, Tabs } from "@mantine/core";
import { useState } from "react";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import Province from "./Province/Province";
import District from "./District/District";
import Commune from "./Commune/Commune";

const Address = () => {
  const [activeTab, setActiveTab] = useState<string | null>("province");
  const breadCrumb = false;

  return (
    <>
      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "0px 10px",
        }}
      >
        <BreadcrumbLayout1></BreadcrumbLayout1>
      </div>
      <Paper shadow="md" radius="lg">
        <Tabs p={"xs"} value={activeTab} onChange={setActiveTab}>
          <Tabs.List>
            <Tabs.Tab value="province">Danh mục tỉnh thành</Tabs.Tab>
            {/* <Tabs.Tab value="district">Danh mục huyện</Tabs.Tab> */}
            <Tabs.Tab value="commune">Danh mục xã</Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="province">
            {activeTab === "province" ? <Province /> : <></>}
          </Tabs.Panel>
          {/* <Tabs.Panel value="district">
            {activeTab === "district" ? <District /> : <></>}
          </Tabs.Panel> */}
          <Tabs.Panel value="commune">
            {activeTab === "commune" ? <Commune /> : <></>}
          </Tabs.Panel>
        </Tabs>
      </Paper>
    </>
  );
};

export default Address;
